function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n            .cls-11,.cls-22{fill:#e30a17;fill-rule:evenodd}.cls-22{fill:#fff}\r\n        "));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "Path_21580",
  d: "M0 0h28.577v21.433H0z",
  className: "cls-11",
  "data-name": "Path 21580"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  id: "Path_21581",
  d: "M173.9 132.954a5.448 5.448 0 1 1-5.448-5.354 5.4 5.4 0 0 1 5.448 5.354z",
  className: "cls-22",
  "data-name": "Path 21581",
  transform: "translate(-155.722 -121.902)"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  id: "Path_21582",
  d: "M226.612 155.882a4.356 4.356 0 1 1-4.354-4.282 4.316 4.316 0 0 1 4.354 4.282z",
  className: "cls-11",
  "data-name": "Path 21582",
  transform: "translate(-208.17 -144.831)"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  id: "Path_21583",
  d: "M390.289 191.4l-.045 1.978-1.844.5 1.822.647-.045 1.817 1.183-1.42 1.795.625-1.036-1.523 1.264-1.514-1.942.536-1.152-1.652z",
  className: "cls-22",
  "data-name": "Path 21583",
  transform: "translate(-371.057 -182.854)"
});

var SvgTr = function SvgTr(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "tr",
    width: 28.577,
    height: 21.433,
    viewBox: "0 0 28.577 21.433",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTr, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/tr.9161680a.svg";
export { ForwardRef as ReactComponent };